import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Tickets.css';

function Tickets() {
    const navigate = useNavigate();

    return (
        <div className="tickets-page">
            {/* Video Background */}
            <div className="tickets-video-container">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="tickets-background-video"
                >
                    <source src="/rotb_big.mp4" type="video/mp4" />
                </video>
                <div className="tickets-video-overlay"></div>
            </div>

            <main className="event-container">
                <div className="event-content tickets-coming-soon">
                    <h1 className="event-title">PHASE 9</h1>
                    <p className="tickets-loading">loading...</p>
                    <div className="tickets-loading-track" aria-hidden="true">
                        <span />
                    </div>
                    <p className="tickets-announcement">Ticket info coming soon.</p>
                </div>
            </main>

            {/* Navigation */}
            <div className="tickets-navigation">
                <button className="home-btn" onClick={() => navigate('/')}>
                    HOME
                </button>
            </div>
        </div>
    );
}

export default Tickets;
